module.exports = __webpack_public_path__ + "static/media/gomapped.43f40d7c.png";